import os from 'node:os'
import * as Sentry from '@sentry/node'

/**
 * Server-side Sentry initialization for SSR.
 * Mirrors pixai-server's sentry.ts pattern using @sentry/node v7.
 * Import this module as a side-effect in entry.server.tsx.
 *
 * Guarded against duplicate init during Vite SSR HMR.
 */
const g = globalThis as any
if (!g.__pixaiSsrSentryInitialized) {
  g.__pixaiSsrSentryInitialized = true

  Sentry.init({
    enabled: process.env.SENTRY_ENABLED === 'true',
    dsn: process.env.SENTRY_DSN || process.env.VITE_SENTRY_DSN,
    environment: process.env.ENV_TAG || process.env.NODE_ENV || 'unknown',
    release: process.env.GIT_COMMIT_ID || process.env.VITE_COMMIT_HASH,
    sendDefaultPii: true,
    sampleRate: 1,
    tracesSampleRate: 0.01,
    initialScope(scope) {
      scope.setTag('app', 'pixai-app-ssr')
      scope.setTag('pid', process.pid)
      scope.setTag('host', os.hostname())
      return scope
    },
    integrations: [
      new Sentry.Integrations.Http(),
      new Sentry.Integrations.OnUncaughtException(),
      new Sentry.Integrations.OnUnhandledRejection(),
      new Sentry.Integrations.ContextLines(),
    ],
    ignoreErrors: [
      'ECONNRESET',
      'ECONNREFUSED',
      'ETIMEDOUT',
      'socket hang up',
      'AbortError',
    ],
  })

  process.once('SIGTERM', async () => {
    await Sentry.close(5000)
  })
}

export default Sentry
